module.exports = __webpack_public_path__ + "media/application/images/svgs/battery-charging-1bbd3eeea187be2cf98cc62dba0197b7.svg";